module.exports = __webpack_public_path__ + "static/media/sendMessageIcon.826edec7.svg";